import React from 'react';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'brand' | 'success' | 'white';
  className?: string;
}

const SIZE_STYLES: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-8 h-8 border-[3px]',
};

const VARIANT_STYLES: Record<NonNullable<SpinnerProps['variant']>, string> = {
  brand: 'border-brand/30 border-t-brand',
  success: 'border-status-success/30 border-t-status-success',
  white: 'border-white/30 border-t-white',
};

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ size = 'md', variant = 'brand', className = '' }, ref) => {
    const classes = [
      'rounded-full animate-spin',
      SIZE_STYLES[size],
      VARIANT_STYLES[variant],
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <div ref={ref} className={classes} role="status" aria-live="polite">
        <span className="sr-only">Loading...</span>
      </div>
    );
  },
);

Spinner.displayName = 'Spinner';

export default Spinner;
